import React, { useEffect, useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Pagination } from 'react-bootstrap';
import axios from 'axios';
import { USERS_URL, STUDENT_DATA_URL } from '../apiConfig';
import { TailSpin } from 'react-loader-spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faArrowLeft, faPencil, faListAlt } from '@fortawesome/free-solid-svg-icons';
import AttendanceModal from './AttendanceModal'; 
import StudentDetailsModal from './StudentDetailsModal'; // Importar el modal
import { start } from '@popperjs/core';
import debounce from 'lodash.debounce';
import {
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';

const SupervisorResumen = () => {
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [studentData, setStudentData] = useState([]);
    const [studentDetails, setStudentDetails] = useState([]);
    const [startDate, setStartDate] = useState(() => {
        const date = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000); // 7 días atrás
        date.setHours(0, 0, 0, 0); // Establecer la hora a 00:00:00
        return date;
    });
    const [endDate, setEndDate] = useState(() => {
        const date = new Date();
        date.setHours(23, 59, 59, 999); // Establecer la hora a 23:59:59
        return date;
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [isViewingDetails, setIsViewingDetails] = useState(false);
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Token ${token}` };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isStudentDetailsModalOpen, setIsStudentDetailsModalOpen] = useState(false); 
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    // const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        document.body.className = theme; // Aplica la clase 'light' o 'dark' al body
    }, []);

    // Reemplazar el useState de students y useEffect por:
    const [filters, setFilters] = useState({
        search: '',
        page: 1,
        page_size: 20,
        // is_active: true,
        allowed: true, // Agregar filtro para buscar por allowed
        student: true
    });
    
    const buildApiParams = () => ({
        search: filters.search,
        page: filters.page,
        page_size: filters.page_size,
        // is_active: filters.is_active
        allowed: filters.allowed !== 'true' && filters.allowed !== true ? undefined : true, 
        student: filters.student
    });
    
    const fetchStudents = async () => {
        const params = new URLSearchParams(buildApiParams());
        const response = await axios.get(USERS_URL, { 
        headers,
        params 
        });
        // console.log(response.data);
        // console.log(response.data.results);
        setStudents(response.data.results);
        return response.data;
    };
    
    const { data, isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['students', filters],
        queryFn: fetchStudents,
        keepPreviousData: true,
        staleTime: 30000
    });

    
    const fetchStudentData = async (selectedStudent,
        start_date2 = (() => {
          const date = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000); // 7 días atrás
          date.setHours(0, 0, 0, 0); // Establecer la hora a 00:00:00
          return date;
        })(),
        end_date2 = (() => {
          const date = new Date();
          date.setHours(23, 59, 59, 999); // Establecer la hora a 23:59:59
          return date;
        })()
      ) => {
        setLoading(true);
        try {
            const response = await axios.get(STUDENT_DATA_URL, {
                headers,
                params: {
                    student_id: selectedStudent,
                    start_date: start_date2.toISOString(),//.split('T')[0],
                    end_date: end_date2.toISOString()//.split('T')[0],
                },
            });
            const { prospection } = response.data;
            setStudentDetails(response.data)
            // console.log(response.data);
            const combinedData = combineDataByDate(prospection,start_date2, end_date2);
            setStudentData(combinedData);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.error('Unauthorized, removing token');
                localStorage.removeItem('token'); // Eliminar token si es un 401
                alert('Debes iniciar sesión nuevamente.');
                window.location.href = '/'; // Redirigir a /login
        
            } else {
            console.error('Error fetching student data:', error);
        }} finally {
            setIsViewingDetails(true);
            setLoading(false);
        }
    };
    // // Cerrar el modal después de guardar los datos
    // const handleModalClose = () => {
    //     setIsModalOpen(false);
    // }

    const handleDateChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    const handleFetchLastWeek = () => {
        const newStartDate = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000);
        newStartDate.setHours(0, 0, 0, 0); // Establecer la hora a 00:00:00

        const newEndDate = new Date();
        newEndDate.setHours(23, 59, 59, 999); // Establecer la hora a 23:59:59

        handleDateChange(newStartDate, newEndDate);
        setTimeout(() => fetchStudentData(selectedStudent, newStartDate, newEndDate), 0); // Espera a que se actualicen las fechas antes de hacer la solicitud
    };

    const handleFetchLastMonth = () => {
        const newStartDate = new Date(Date.now() - 29 * 24 * 60 * 60 * 1000);
        newStartDate.setHours(0, 0, 0, 0); // Establecer la hora a 00:00:00

        const newEndDate = new Date();
        newEndDate.setHours(23, 59, 59, 999); // Establecer la hora a 23:59:59

        handleDateChange(newStartDate, newEndDate);
        setTimeout(() => fetchStudentData(selectedStudent, newStartDate, newEndDate), 0); // Espera a que se actualicen las fechas antes de hacer la solicitud
    };
    
    const handleFilterClick = () => {
        fetchStudentData(selectedStudent, startDate, endDate); // Realiza la solicitud manualmente solo cuando se hace clic en el botón Filtrar
    };

    const combineDataByDate = (prospection, startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const dateMap = new Map();
    
        prospection.forEach((item) => {
            // Extraer solo la parte de la fecha (sin la hora)
            const dateStr = item.date.split('T')[0];
            dateMap.set(dateStr, {
                fecha: dateStr,
                contactos_parte_1_enviada: item.contactos_parte_1_enviada || 0,
                contactos_parte_2_enviada: item.contactos_parte_2_enviada || 0,
                reuniones_realizadas: item.reuniones_realizadas || 0,
            });
        });
    
        const result = [];
        for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const dateStr = dt.toISOString().split('T')[0]; // Formatear la fecha sin la hora
            if (!dateMap.has(dateStr)) {
                dateMap.set(dateStr, {
                    fecha: dateStr,
                    contactos_parte_1_enviada: 0,
                    contactos_parte_2_enviada: 0,
                    reuniones_realizadas: 0,
                });
            }
            result.push(dateMap.get(dateStr));
        }
    
        // Ordenar las fechas de manera descendente
        return result.sort((b, a) => new Date(a.fecha) - new Date(b.fecha));
    };
    


    const handleViewDetails = (studentId) => {
        setSelectedStudent(studentId);
        fetchStudentData(studentId) 
        };

    const handleBackToStudentList = () => {
        setIsViewingDetails(false);
    };


    const sumColumn = (key) => {
        return studentData.reduce((sum, row) => sum + (parseInt(row[key], 10) || 0), 0);
    };

    const handleOpenStudentDetailsModal = () => {
        setIsStudentDetailsModalOpen(true); // Abrir modal
    };
    // Reemplazar handleSearch actual por:
    const handleSearch = React.useMemo(
        () => debounce((value) => {
            setFilters(prev => ({...prev, search: value, page: 1}));
        }, 1000),
        []
    );

    // Crear memoized selectedStudent
    const selectedStudentData = useMemo(() => ({
        student: data?.results?.find(s => s.id === selectedStudent),
        details: studentDetails?.student_details?.find(s => s.user === selectedStudent)
    }), [data, studentDetails, selectedStudent]);
    
    return (
        <div className={`container mt-5 p-4 rounded ${theme === "light" ? "bg-light text-black" : "bg-dark text-white"}`}>
            <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                <h1 className="mb-0">Supervisión - Resumen de Alumnos</h1>
            </div>
          
            {!isViewingDetails ? (
                <div className={`card p-4 rounded ${theme === "light" ? "bg-light text-black" : "bg-dark text-white"}`}>
                    <div className="mb-3">
                        <h3>Alumnos</h3>
                        <div className='d-flex flex-row justify-content-between'>
                            <input
                                type="text"
                                placeholder="Buscar por nombre"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    handleSearch(e.target.value);
                                }}                            
                                className={`form-control mb-2 mx-4 ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                            />
                            <FormControl variant="outlined" size="small" sx={{ minWidth: 120, mx: 1, py: 1 }}>
                                        <InputLabel
                                        style={{
                                            color: theme === "dark" ? "white" : "#000"
                                        }}
                                        >
                                        Estado
                                        </InputLabel>
                                        <Select
                                        value={filters.allowed}
                                        onChange={(e) => setFilters(prev => ({...prev, allowed: e.target.value}))}
                                        label="Estado"
                                        className={` ${theme === "light" ? "" : "input-theme-black text-light"}`}
                                        data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                                        > 
                                        <MenuItem value="all">Todos</MenuItem>
                                        <MenuItem value="true">Activos</MenuItem>
                                        </Select>
                            </FormControl>
                        </div>
                        {/* // Actualizar loading states usando isLoading e isFetching */}
                        {(isLoading || isFetching) && (
                        <div className="d-flex justify-content-center mt-3">
                            <TailSpin color="#007bff" height={50} width={50} />
                        </div>
                        )}
                        {loading ?  (
                    <div className="d-flex justify-content-center mt-3">
                        <TailSpin color="#007bff" height={50} width={50} />
                    </div>
                        ) : (
                        <ul className="mt-5 list-group">
                            {data?.results
                                .filter(student => (
                                    `${student.first_name} ${student.last_name}`
                                    .toLowerCase().includes(filters.search.toLowerCase()) && 
                                    student.is_supervisor === "Estudiantes"
                                ))
                                .map((student) => (
                                    <li key={student.id} className={`border-secondary list-group-item d-flex justify-content-between align-items-center ${theme === "light" ? "bg-light text-black" : "bg-dark text-white"}`}>
                                        {student.first_name} {student.last_name}
                                        <button className="btn btn-sm btn-outline-primary" onClick={() => handleViewDetails(student.id)}>
                                            <FontAwesomeIcon icon={faEye} /> Ver detalles
                                        </button>
                                    </li>
                                ))}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span>Total alumnos: {data?.count || 0}</span>
                            </div>
                        </ul>)}
                        {/* // Después del listado de estudiantes */}
                        {data?.count > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <Pagination className="mb-0">
                                <Pagination.Prev
                                    onClick={() => setFilters(prev => ({...prev, page: prev.page - 1}))}
                                    disabled={filters.page === 1 || isFetching}
                                />
                                
                                {[...Array(Math.ceil(data.count / filters.page_size)).keys()].map(page => (
                                    <Pagination.Item
                                    key={page + 1}
                                    active={page + 1 === filters.page}
                                    onClick={() => setFilters(prev => ({...prev, page: page + 1}))}
                                    >
                                    {page + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next
                                    onClick={() => setFilters(prev => ({...prev, page: prev.page + 1}))}
                                    disabled={!data?.next || isFetching}
                                />
                                </Pagination>

                                <div className="ms-3">
                                <select 
                                    className="form-select form-select-sm"
                                    value={filters.page_size}
                                    onChange={(e) => setFilters(prev => ({
                                    ...prev,
                                    page_size: Number(e.target.value),
                                    page: 1
                                    }))}
                                >
                                    {[10, 20, 50].map(size => (
                                    <option key={size} value={size}>
                                        {size} por página
                                    </option>
                                    ))}
                                </select>
                                </div>
                            </div>
                            )}
                    </div>
                </div>
            ) : (
                <div className='m-3'>
                    <div className='d-flex'>
                        <button className="btn btn-outline-primary m-4" onClick={handleBackToStudentList}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Volver a la lista de alumnos
                        </button>

                        <button className="btn btn-primary m-4" onClick={() => setIsModalOpen(true)}>
                            Asistencia de alumnos</button>
                            {isModalOpen && (
                                <AttendanceModal 
                                    show={isModalOpen} 
                                    handleClose={() => setIsModalOpen(false)} 
                                    student={students.find((s) => s.id === selectedStudent)} 
                                />
                            )}
                        <button onClick={handleOpenStudentDetailsModal} className="btn m-4 btn-outline-info">
                            Ver detalles del estudiante
                        </button>
                    </div>
                    <h3>

                    Datos de {students.find((s) => s.id === selectedStudent)?.first_name ?? 'N/A'}{' '}
                    {/* {console.log(students, selectedStudent)} */}
                    {students.find((s) => s.id === selectedStudent)?.last_name ?? 'N/A'}
                    </h3>
                    <div className="student-data m-auto">   
                    <div className="m-3">
                        {/* <p>
                        Último inicio de sesión:&nbsp; 
                        {students.find((s) => s.id === selectedStudent)?.last_login 
                            ? students.find((s) => s.id === selectedStudent)?.last_login.toString().split('.')[0].replace('T', ' ') 
                            : 'No disponible'}
                        </p> */}
                        <p>
                        Ingreso al Milki Challenge:&nbsp; 
                        {students.find((s) => s.id === selectedStudent)?.date_joined 
                            ? new Date(students.find((s) => s.id === selectedStudent)?.date_joined.toString().split('T')[0]).toLocaleDateString('es-ES')
                            : 'No disponible'}
                        </p>
                        <p>
                            Días en el Milki Challenge:&nbsp;
                            {(() => {
                                const student = students.find((s) => s.id === selectedStudent);
                                if (student?.date_joined) {
                                const joinedDate = new Date(student.date_joined);
                                if (!isNaN(joinedDate)) {
                                    const diffInMs = new Date() - joinedDate;
                                    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
                                }
                                }
                                return 'No disponible'; // Para fecha inválida o no existente
                            })()}
                        </p>
                    </div>
                    <div className="m-3"> 
                        <p>
                        Nicho:&nbsp;
                        {studentDetails?.student_details?.find((s) => s.user === selectedStudent)?.niche ?? 'No disponible'}
                        </p>
                        <p>
                        País de prospección:&nbsp;
                        {studentDetails?.student_details?.find((s) => s.user === selectedStudent)?.prosp_country ?? 'No disponible'}
                        </p>
                    </div>
                    <div className="m-3">
                        <p>
                        Último cliente cerrado:&nbsp;
                        {studentDetails?.client_data?.fecha_ultimo_cliente?.created_at 
                            ? new Date(studentDetails.client_data.fecha_ultimo_cliente.created_at).toLocaleDateString('es-ES')
                            : 'No disponible'}
                        </p>
                        <p>
                        Cantidad de clientes:&nbsp;
                        {studentDetails?.client_data?.cantidad_clientes 
                            ?   studentDetails.client_data.cantidad_clientes
                            : 'No disponible'}
                        </p>
                    </div>
                    {/* Modal para los detalles del estudiante */}
                    {isStudentDetailsModalOpen && (
                        <StudentDetailsModal
                        studentDetails={studentDetails}
                        setStudentDetails={setStudentDetails}
                        handleClose={() => setIsStudentDetailsModalOpen(false)}
                        selectedStudent={selectedStudent}
                        fetchStudentData={fetchStudentData}
                        />
                    )}
                    </div>

                    <div className="d-flex mb-3">
                        <div className="me-4">
                            <label>Fecha Inicio:</label>
                            <input
                                type="date"
                                value={startDate.toISOString().split('T')[0]}
                                className={`form-control mb-2 ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    const regex = /\d{4}-\d{2}-\d{2}/
                                    if (regex.test(inputValue) && inputValue.length <= 10) {
                                        const selectedDate = new Date(`${inputValue}T00:00:00`); // Mantén la hora en UTC (medianoche)
                                        selectedDate.setUTCHours(23, 59, 59, 999); // Ajusta la hora a  UTC
                                        setStartDate(selectedDate);
                                    }
                                  }}
                            />
                        </div>
                        <div className="me-4">
                            <label>Fecha Fin:</label>
                            <input
                                type="date"
                                value={endDate.toISOString().split('T')[0]}
                                className={`form-control mb-2 ${theme === "light" ? "" : "input-theme-black"}`}
                                data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    const regex = /\d{4}-\d{2}-\d{2}/
                                    if (regex.test(inputValue) && inputValue.length <= 10) {         
                                        const selectedDate = new Date(`${inputValue}T00:00:00`); // Mantén la hora en UTC (medianoche)
                                        selectedDate.setUTCHours(23, 59, 59, 999); // Ajusta la hora a 23:59:59 UTC
                                        setEndDate(selectedDate);
                                    }
                                  }}
                            />
                        </div>
                        <div className="d-flex  align-middle">
                            <button onClick={handleFilterClick} className="btn btn-sm btn-primary">Filtrar</button>
                            <button onClick={handleFetchLastWeek} className="btn btn-sm btn-secondary ms-2">Última Semana</button>
                        
                            <button onClick={handleFetchLastMonth} className="btn btn-sm btn-secondary ms-2">Último Mes</button>
                        </div>
                    </div>
                {studentData.length > 0 ? (loading ?  (
                    <div className="d-flex justify-content-center mt-3">
                        <TailSpin color="#007bff" height={50} width={50} />
                    </div>
                        ) : 
                        <table className={`table p-5 table-hover ${theme === "light" ? "bg-light text-black" : "table-dark"}`}>
                            <thead className={`${theme === "light" ? "table-success" : "thead-dark"}`}>
                                <tr>
                                    <th>Fecha</th>
                                    <th>1ra Parte Enviada</th>
                                    <th>2da Parte Enviada</th>
                                    <th>Reuniones Realizadas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className={`${theme === "light" ? "table-secondary" : "thead-dark"}`}>
                                    <td>Total</td>
                                    <td>{sumColumn('contactos_parte_1_enviada')}</td>
                                    <td>{sumColumn('contactos_parte_2_enviada')}</td>
                                    <td>{sumColumn('reuniones_realizadas')}</td>
                                </tr>
                                {studentData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.fecha}</td>
                                        <td>{data.contactos_parte_1_enviada}</td>
                                        <td>{data.contactos_parte_2_enviada}</td>
                                        <td>{data.reuniones_realizadas}</td>
                                    </tr>
                                ))}
                                
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-danger">No se encontraron datos para este estudiante en el rango de fechas seleccionado.</p>
                    )} 
                </div>
            )}
        </div>
    );
};

export default SupervisorResumen;
